module.exports = __webpack_public_path__ + "static/media/unknow_pic.2b2dc2b3.jpg";